import { Box, Pagination, Stack } from "@mui/material"
import { setFromValueParam } from "lib/setFromEvent"
import { GenericPaginationBar } from "slot-definitions"
import { PageSize } from "lib/@components/pagination/page-size"

export function GenericPagination({
    disableRowsPerPage = false,
    numberOfPages,
    currentPage,
    changeRowsPerPage,
    take,
    changePage,
    pageInfo,
    showPageInfo = false,
}) {
    return (
        <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems="center"
            justifyContent={showPageInfo ? "space-between" : "space-evenly"}
        >
            <GenericPaginationBar.Slot />
            {showPageInfo && pageInfo}
            <Box flex={1} />
            <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between">
                {!disableRowsPerPage && <PageSize take={take} setTake={changeRowsPerPage} />}

                <Pagination
                    color="primary"
                    onChange={setFromValueParam(changePage)}
                    shape="circular"
                    size="small"
                    count={numberOfPages}
                    page={currentPage}
                />
            </Stack>
        </Stack>
    )
}

export default GenericPagination
